module.exports = __webpack_public_path__ + "static/media/mountains-between-the-body-of-water-1482931.acd669b1.jpg";